import type { ContinueGuard } from './types'

export const validateContinueGuards = (guards: ContinueGuard[]) => {
  const ids = new Set<string>()

  guards.forEach(({ id }) => {
    if (ids.has(id)) {
      throw new Error(`Duplicate booking Continue guard id: ${id}`)
    }
    ids.add(id)
  })
}

export const runContinueGuards = async (guards: ContinueGuard[]): Promise<boolean> => {
  validateContinueGuards(guards)

  for (const guard of guards) {
    if (!(await guard.run())) {
      return false
    }
  }

  return true
}
